import { BackendDataSource } from './backend'
import type { VehicleDataSource } from './types'
export { isSafeToWakeCar } from '@/services/socket'

export const dataSource: VehicleDataSource = new BackendDataSource()
